/**
 *
 * @param {number} views
 * @param {number} clicks
 * @returns {number}
 */
export default function calculateCtr(views, clicks) {
  return parseFloat((((clicks || 0) / (views || 0)) * 100).toFixed(2));
}
